export default __webpack_public_path__ + "static/media/linkedin-color-square.6340b9cb.svg";